const CATEGORY_TRANSLATIONS = {
  General: { th: 'ทั่วไป', en: 'General' },
  Academic: { th: 'วิชาการ', en: 'Academic' },
  Financial: { th: 'การเงิน', en: 'Financial' },
  Legal: { th: 'กฎหมาย', en: 'Legal' },
  'Dispute Resolution': { th: 'การระงับข้อพิพาท', en: 'Dispute Resolution' },
  Termination: { th: 'การยุติข้อตกลง', en: 'Termination' },
  Confidentiality: { th: 'การรักษาความลับ', en: 'Confidentiality' },
  'IP Rights': { th: 'สิทธิในทรัพย์สินทางปัญญา', en: 'IP Rights' },
  Validity: { th: 'ระยะเวลาการมีผลบังคับใช้', en: 'Validity' }
}

const TITLE_TRANSLATIONS = {
  'Purpose of Cooperation': { th: 'วัตถุประสงค์ของความร่วมมือ', en: 'Purpose of Cooperation' },
  'Student Mobility': { th: 'การเคลื่อนย้ายนักศึกษา', en: 'Student Mobility' },
  'Financial Responsibilities': { th: 'ความรับผิดชอบด้านการเงิน', en: 'Financial Responsibilities' },
  Confidentiality: { th: 'การรักษาความลับ', en: 'Confidentiality' },
  Termination: { th: 'การยุติข้อตกลง', en: 'Termination' },
  'Dispute Resolution - Escalation to Senior Leadership': { th: 'การระงับข้อพิพาท - ส่งต่อสู่ผู้บริหารระดับสูง', en: 'Dispute Resolution - Escalation to Senior Leadership' },
  'Dispute Resolution - Bilateral Jurisdiction': { th: 'การระงับข้อพิพาท - เขตอำนาจศาลของทั้งสองฝ่าย', en: 'Dispute Resolution - Bilateral Jurisdiction' },
  'Dispute Resolution - Mutual Consultation': { th: 'การระงับข้อพิพาท - การปรึกษาหารือร่วมกัน', en: 'Dispute Resolution - Mutual Consultation' },
  'Dispute Resolution - Friendly Consultation': { th: 'การระงับข้อพิพาท - การปรึกษาหารือโดยสันติ', en: 'Dispute Resolution - Friendly Consultation' },
  'Dispute Resolution with Mediation': { th: 'การระงับข้อพิพาทด้วยการไกล่เกลี่ย', en: 'Dispute Resolution with Mediation' },
  'Dispute Resolution - Mutual Trust': { th: 'การระงับข้อพิพาท - บนพื้นฐานความไว้วางใจร่วมกัน', en: 'Dispute Resolution - Mutual Trust' },
  'Dispute Resolution': { th: 'การระงับข้อพิพาท', en: 'Dispute Resolution' },
  'Termination - 6 Months': { th: 'การยุติข้อตกลง - แจ้งล่วงหน้า 6 เดือน', en: 'Termination - 6 Months' },
  'Termination - 30 Days': { th: 'การยุติข้อตกลง - แจ้งล่วงหน้า 30 วัน', en: 'Termination - 30 Days' },
  'Termination - 6 Months (Alternative)': { th: 'การยุติข้อตกลง - แจ้งล่วงหน้า 6 เดือน (ทางเลือก)', en: 'Termination - 6 Months (Alternative)' },
  'Termination - 30 Days (Alternative)': { th: 'การยุติข้อตกลง - แจ้งล่วงหน้า 30 วัน (ทางเลือก)', en: 'Termination - 30 Days (Alternative)' },
  'Termination - 60 Days': { th: 'การยุติข้อตกลง - แจ้งล่วงหน้า 60 วัน', en: 'Termination - 60 Days' },
  'Termination - 90 Days': { th: 'การยุติข้อตกลง - แจ้งล่วงหน้า 90 วัน', en: 'Termination - 90 Days' },
  'Termination - 120 Days': { th: 'การยุติข้อตกลง - แจ้งล่วงหน้า 120 วัน', en: 'Termination - 120 Days' },
  'Termination - 6 Months with Completion': { th: 'การยุติข้อตกลง - แจ้งล่วงหน้า 6 เดือนพร้อมให้กิจกรรมเดิมเสร็จสิ้น', en: 'Termination - 6 Months with Completion' },
  'Termination - 180 Days': { th: 'การยุติข้อตกลง - แจ้งล่วงหน้า 180 วัน', en: 'Termination - 180 Days' },
  'Termination for Cause': { th: 'การยุติข้อตกลงกรณีมีเหตุ', en: 'Termination for Cause' },
  'Force Majeure Termination': { th: 'การยุติข้อตกลงเนื่องจากเหตุสุดวิสัย', en: 'Force Majeure Termination' },
  'Termination with Completion': { th: 'การยุติข้อตกลงโดยให้โครงการที่กำลังดำเนินอยู่เสร็จสิ้น', en: 'Termination with Completion' },
  'Confidentiality of Information': { th: 'การรักษาความลับของข้อมูล', en: 'Confidentiality of Information' },
  'Personal Health Information': { th: 'ข้อมูลสุขภาพส่วนบุคคล', en: 'Personal Health Information' },
  'Fellow Confidentiality': { th: 'การรักษาความลับของผู้รับทุน/ผู้เข้าร่วม', en: 'Fellow Confidentiality' },
  'Data Protection & Privacy': { th: 'การคุ้มครองข้อมูลและความเป็นส่วนตัว', en: 'Data Protection & Privacy' },
  'Joint Ownership of IP': { th: 'การเป็นเจ้าของทรัพย์สินทางปัญญาร่วมกัน', en: 'Joint Ownership of IP' },
  'Publication Credit': { th: 'การให้เครดิตในผลงานตีพิมพ์', en: 'Publication Credit' },
  'IP Compliance': { th: 'การปฏิบัติตามข้อกำหนดด้านทรัพย์สินทางปัญญา', en: 'IP Compliance' },
  'Publication Pre-Approval': { th: 'การอนุมัติก่อนเผยแพร่', en: 'Publication Pre-Approval' },
  'Acknowledgment of Agreement': { th: 'การอ้างอิงถึงข้อตกลง', en: 'Acknowledgment of Agreement' },
  'IP - Sole Ownership': { th: 'ทรัพย์สินทางปัญญา - กรรมสิทธิ์ฝ่ายเดียว', en: 'IP - Sole Ownership' },
  'IP - Joint Research with Equal Rights': { th: 'ทรัพย์สินทางปัญญา - งานวิจัยร่วมโดยมีสิทธิเท่าเทียม', en: 'IP - Joint Research with Equal Rights' },
  'IP - Joint Commercial Exploitation': { th: 'ทรัพย์สินทางปัญญา - การใช้ประโยชน์เชิงพาณิชย์ร่วมกัน', en: 'IP - Joint Commercial Exploitation' },
  'IP - Academic Research Use License': { th: 'ทรัพย์สินทางปัญญา - สิทธิการใช้เพื่อการวิจัยทางวิชาการ', en: 'IP - Academic Research Use License' },
  'IP - Pre-Existing IP': { th: 'ทรัพย์สินทางปัญญา - สิทธิที่มีอยู่เดิม', en: 'IP - Pre-Existing IP' },
  'IP - Collaborative Development': { th: 'ทรัพย์สินทางปัญญา - การพัฒนาร่วมกัน', en: 'IP - Collaborative Development' },
  'Term - 2 Years': { th: 'ระยะเวลา - 2 ปี', en: 'Term - 2 Years' },
  'Term - 5 Years': { th: 'ระยะเวลา - 5 ปี', en: 'Term - 5 Years' },
  'Term - 5 Years with Automatic Renewal': { th: 'ระยะเวลา - 5 ปีพร้อมต่ออายุอัตโนมัติ', en: 'Term - 5 Years with Automatic Renewal' },
  'Term - Effective upon Signature': { th: 'ระยะเวลา - มีผลเมื่อมีการลงนาม', en: 'Term - Effective upon Signature' },
  'Effective Period': { th: 'ระยะเวลาที่มีผลบังคับใช้', en: 'Effective Period' },
  'Non-Binding Term': { th: 'ข้อกำหนดที่ไม่มีผลผูกพันทางกฎหมาย', en: 'Non-Binding Term' },
  'Review Provision': { th: 'ข้อกำหนดการทบทวนข้อตกลง', en: 'Review Provision' }
}

function normalizedLocale(locale) {
  return String(locale || 'en').toLowerCase().startsWith('th') ? 'th' : 'en'
}

function translatedValue(map, sourceValue, locale) {
  const entry = map[String(sourceValue || '').trim()]
  const nextLocale = normalizedLocale(locale)
  return entry && entry[nextLocale] ? entry[nextLocale] : String(sourceValue || '')
}

export function translateClauseCategory(category, locale) {
  return translatedValue(CATEGORY_TRANSLATIONS, category, locale)
}

export function translateClauseTitle(title, locale) {
  return translatedValue(TITLE_TRANSLATIONS, title, locale)
}

export function localizeClauseRecord(item, locale) {
  const nextLocale = normalizedLocale(locale)
  const localizedTitle = nextLocale === 'th'
    ? (item && (item.titleTh || item.title_th)) || translateClauseTitle(item && item.title, nextLocale)
    : (item && (item.titleEn || item.title_en || item.title)) || translateClauseTitle(item && item.title, nextLocale)
  const localizedContent = nextLocale === 'th'
    ? (item && (item.contentTh || item.content_th)) || (item && item.content) || ''
    : (item && (item.contentEn || item.content_en || item.content)) || ''
  const localizedCategory = nextLocale === 'th'
    ? (item && (item.categoryTh || item.category_th)) || translateClauseCategory(item && item.category, nextLocale)
    : (item && (item.categoryEn || item.category_en || item.category)) || translateClauseCategory(item && item.category, nextLocale)

  return {
    ...item,
    title: localizedTitle,
    content: localizedContent,
    category: localizedCategory
  }
}
